"use client";
// Re-export from shared. Canonical: WEB/SHARED/components/pages/nolayout-layout.tsx
export { default } from "shared/components/pages/nolayout-layout";
